import { useQueries, useQuery } from "react-query";
import { doc, getDoc, getFirestore, updateDoc } from "firebase/firestore";
import { IRawCompany, TRawCompany } from "@propely/propely-typings";

// Method to get a property fetch key
export const useCompanyByIDKey = (id: string | undefined) => ["companies-raw", { id }];

// Method to fetch a property
const fetchCompany = async (id: string | undefined) => {
  if (!id) {
    return undefined;
  }
  const company = await getDoc(doc(getFirestore(), "companies", id));
  return TRawCompany.parse({
    id: company.id,
    ...company.data(),
  });
};

export const useCompanyByID = (id: string | undefined) => {
  const $company = useQuery(useCompanyByIDKey(id), () => fetchCompany(id));
  return {
    $company,
    company: $company.data,
  };
};

export const useCompaniesByIDs = (ids: string[]) => {
  const $companies = useQueries(
    ids.map((id) => ({
      queryKey: useCompanyByIDKey(id),
      queryFn: () => fetchCompany(id),
    }))
  );

  const companies = $companies.map(($company) => $company.data).filter((data): data is IRawCompany => Boolean(data));
  const isLoading = $companies.some(($company) => $company.isLoading);

  return {
    $companies,
    companies,
    isLoading,
  };
};

// TODO: Find a way to make data be Omit<Partial<IRawCompany>, "id"> and allow arrayUnion
export const updateCompany = async (userID: string, companyID: string, data: { [key: string]: any }) => {
  await updateDoc(doc(getFirestore(), "companies", companyID), {
    ...data,
    updatedBy: {
      userID,
      date: new Date(),
    },
  });
};
